export default __webpack_public_path__ + "static/media/play.3ef54011.svg";